import axiosPost from "../../axiosPost";
import { respuestaDe } from "../../respuesta";

export const RNHFeriadoSerieIns = async (credentials, data) => {
  const body = {
    service: "RNHFeriadoSerieIns",
    params: {
      // Number() porque el <select> entrega string — ver README del modulo.
      rnhFeriadoSerieFeriadoId: Number(data?.feriadoId) || null,
      rnhFeriadoSerieFecha: data?.fecha || null
    },
  };
  return respuestaDe(await axiosPost(body, credentials));

};
